import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

function StreetViewIframeTab({ isActive, embedUrl }) {
  const { t } = useTranslation();

  return (
    <Box
      id="street-view-tabpanel"
      role="tabpanel"
      aria-labelledby="street-view-tab"
      hidden={!isActive}
      sx={{ flex: 1, minHeight: 0, display: isActive ? "flex" : "none" }}
    >
      {embedUrl ? (
        <Box sx={{ width: "100%", height: "100%" }}>
          <iframe
            title={t("common.streetView", {
              defaultValue: "Google Street View",
            })}
            src={embedUrl}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            loading="lazy"
            allowFullScreen
            referrerPolicy="no-referrer-when-downgrade"
          />
        </Box>
      ) : (
        <Box sx={{ p: 2, width: "100%", alignSelf: "center" }}>
          <Typography variant="body2" color="text.secondary">
            {t("common.streetViewUnavailable", {
              defaultValue:
                "Street View preview is unavailable, but you can open it in Google Maps.",
            })}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default React.memo(StreetViewIframeTab);
